module.exports = __webpack_public_path__ + "img/partner.7c8ea7b.jpg";